<template>
  <el-dialog v-if="!embedded" v-bind="$attrs" v-on="$listeners">
    <slot></slot>
    <span slot="footer"><slot name="footer"></slot></span>
  </el-dialog>
  <div v-else class="doi-embedded">
    <div class="doi-body"><slot></slot></div>
    <div class="doi-footer"><slot name="footer"></slot></div>
  </div>
</template>

<script>
export default {
  name: 'DialogOrInline',
  inheritAttrs: false,
  props: {
    embedded: { type: Boolean, default: false }
  },
  mounted() {
    if (this.embedded) this.$nextTick(() => this.$emit('open'));
  },
  activated() {
    if (this.embedded) this.$nextTick(() => this.$emit('open'));
  }
};
</script>

<style scoped>
.doi-embedded {
  display: flex;
  flex-direction: column;
  height: 100%;
}
.doi-body {
  flex: 1;
  overflow-y: auto;
  padding: 0 4px;
}
.doi-footer {
  padding: 12px 0 0;
  border-top: 1px solid var(--vtm-line);
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  flex-shrink: 0;
}
</style>
